// app/javascript/components/invoice_shadow.js
class InvoiceElement extends HTMLElement {
	async connectedCallback() {
		let cssHrefs = [];

		if (this.hasAttribute("stylesheet")) {
			cssHrefs.push(this.getAttribute("stylesheet"));
		}

		if (this.hasAttribute("stylesheets")) {
			cssHrefs = JSON.parse(this.getAttribute("stylesheets"));
		}

		const shadow = this.attachShadow({ mode: "open" });

		let cssText = "";

		for (const stylesheet of cssHrefs) {
			try {
				const res = await fetch(stylesheet, { credentials: "same-origin" });
				cssText += await res.text();
			} catch (e) {
				console.error("Failed to fetch template CSS", e);
			}
		}

		const style = document.createElement("style");
		style.textContent = cssText;

		const slotWrap = document.createElement("div");
		// Move light DOM children into the shadow
		while (this.firstChild) slotWrap.appendChild(this.firstChild);

		shadow.append(style, slotWrap);
	}
}
customElements.define("invoice-element", InvoiceElement);
